module.exports = __webpack_public_path__ + "11597b55382636eac9493b2b2a1ec099.svg";